const pushAmbitosNoCelebrados = (data, id, nomenclator, eleccion) => {
  const arrHijos = nomenclator.ambitos[eleccion].find(x => x.c === id)?.h;
  const arrIdHijos = arrHijos?.map(x => nomenclator.ambitos[eleccion][x].c);
  const arrHijosSinDatos = arrIdHijos?.filter(x => !data.some(y => y.name === x));

  arrHijosSinDatos && arrHijosSinDatos.map((e, i) => {
    const obj = {
      name: e,
      value: 'No se celebra',
      label: {
        show: false,
      },
      itemStyle: {
        borderColor: '#fff',
        shadowColor: 'rgba(0, 0, 0, 0.4)',
        shadowBlur: 1,
        emphasis: {
          areaColor: '#eee',
          borderColor: '#fff',
        },
      },
      key: i,
    };
    data.push(obj);
  });

  return data;
};

export default pushAmbitosNoCelebrados;
